import React from 'react';

import '../styling.scss';

const PStyle = (props: any) => {
	return <div className="edfmat_paragraph-spacing">{props.children}</div>;
};

export default PStyle;
